export default __webpack_public_path__ + "static/media/icon_morganite.c4a7e5c5.png";